module.exports = __webpack_public_path__ + "media/customizations/babcockranch/logo-74ef5a57f938eeea953124b597743ff1.png";